import { render, staticRenderFns } from "./LogsAssinaturaPlanos.vue?vue&type=template&id=3a9c52b6&scoped=true&"
import script from "./LogsAssinaturaPlanos.vue?vue&type=script&lang=js&"
export * from "./LogsAssinaturaPlanos.vue?vue&type=script&lang=js&"
import style0 from "./LogsAssinaturaPlanos.vue?vue&type=style&index=0&id=3a9c52b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c52b6",
  null
  
)

export default component.exports